import '@bjb/bjb-web-components/dist/components/jb-components.js';

import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { customElement } from '@bjb-web-components/assets/scripts/CustomElementsUtils';
import type { IInfoCard } from './adesso-info-card.custom.js';
import componentStyles from './adesso-info-card.scss?inline';


/**
 * @attr {IInfoCard['link']} link
 */
@customElement('adesso-info-card')
export class AdessoInfoCard extends LitElement implements IInfoCard {
  static styles = unsafeCSS(componentStyles);

  @property()
  direction: IInfoCard['direction'] = 'vertical';

  @property({ type: Object })
  teaserHeader!: IInfoCard['teaserHeader'];

  render() {
    const classes = {
      horizontal: this.direction === 'horizontal',
      'no-image': !this.teaserHeader.picture && !this.teaserHeader.thumbnail,
    };
    return html`
      <card class="${classMap(classes)}">
        ${this.direction === 'horizontal'
          ? html`
                ${this.teaserHeader.picture
                  ? html`
                      <jb-picture
                        .alt=${this.teaserHeader.picture.alt}
                        .fit=${this.teaserHeader.picture.fit}
                        .imgData=${this.teaserHeader.picture.imgData}
                        .lazy=${this.teaserHeader.picture.lazy}
                      ></jb-picture>
                    `
                  : nothing}
                ${this.teaserHeader.thumbnail
                  ? html`
                      <jb-thumbnail
                        .backgroundPicture="${this.teaserHeader.thumbnail.backgroundPicture}"
                        .videoSrc="${this.teaserHeader.thumbnail.videoSrc}"
                        .aspect="${this.teaserHeader.thumbnail.aspect}"
                        .type="${this.teaserHeader.thumbnail.type}"
                      ></jb-thumbnail>
                    `
                  : nothing}
            `
          : nothing}
        <div class="wrapper">
            ${this.direction !== 'horizontal'
              ? html`
                  <adesso-info-teaser-header
                    .headline=${this.teaserHeader.headline}
                    .picture=${this.teaserHeader.picture}
                    .teaser=${this.teaserHeader.teaser}
                    .thumbnail=${this.teaserHeader.thumbnail}
                    .maxLines=${this.teaserHeader.maxLines}
                  ></adesso-info-teaser-header>
                `
              : html` <h3>${this.teaserHeader.headline}</h3> `}
        </div>
      </card>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'adesso-info-card': AdessoInfoCard;
  }
}
